import { GroupSimpleEventAttendancePage } from '@/imports/ui/pages/group/group-event-create-update/GroupSimpleEventAttendancePage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(GroupSimpleEventAttendancePage, {
  requiresEvery: [RouteRestrictions.AUTHENTICATION],
});
